"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trigTimedToQuartzCron = exports.quartzCronToCron = exports.cronToQuartzCron = exports.quartzCronToTrigTimed = void 0;
var quartzCronToTrigTimed = function (quartzString) {
    if (!quartzString)
        return undefined;
    var parts = quartzString.split(' ').slice(0, 6);
    var minuteOfHour = parts[1] === '*' ? undefined : Number(parts[1]);
    var hourOfDay = parts[2] === '*' ? undefined : Number(parts[2]);
    var dayOfMonth = ['*', '?'].includes(parts[3])
        ? undefined
        : Number(parts[3]);
    var dayOfWeek = ['*', '?'].includes(parts[5])
        ? undefined
        : Number(parts[5]) - 1;
    var period;
    if (minuteOfHour !== undefined &&
        hourOfDay === undefined &&
        dayOfMonth === undefined &&
        dayOfWeek === undefined) {
        period = 'hourly';
    }
    else if (minuteOfHour !== undefined &&
        hourOfDay !== undefined &&
        dayOfMonth === undefined &&
        dayOfWeek === undefined) {
        period = 'daily';
    }
    else if (minuteOfHour !== undefined &&
        hourOfDay !== undefined &&
        dayOfMonth === undefined &&
        dayOfWeek !== undefined) {
        period = 'weekly';
    }
    else if (minuteOfHour !== undefined &&
        hourOfDay !== undefined &&
        dayOfMonth !== undefined &&
        dayOfWeek === undefined) {
        period = 'monthly';
    }
    else {
        period = 'unclear';
    }
    return {
        period: period,
        hourOfDay: hourOfDay,
        minuteOfHour: minuteOfHour,
        dayOfWeek: dayOfWeek,
        dayOfMonth: dayOfMonth,
    };
};
exports.quartzCronToTrigTimed = quartzCronToTrigTimed;
// CronScheduleSelect component creates cron strings with 5 elements
// JobOrchestration works with quartz cron strings with 7 elements
var cronToQuartzCron = function (cronString) {
    var split = cronString.split(' ');
    var dayOfTheMonth = split[2];
    var dayOfTheWeek = split[4];
    if (dayOfTheMonth !== '*') {
        split[4] = '?';
    }
    else if (dayOfTheWeek !== '*') {
        split[2] = '?';
    }
    else if (dayOfTheMonth === '*' && dayOfTheWeek === '*') {
        split[2] = '?';
    }
    split.splice(0, 0, '0');
    split.splice(6, 0, '*');
    return split.join(' ');
};
exports.cronToQuartzCron = cronToQuartzCron;
var quartzCronToCron = function (cronString) {
    if (!cronString)
        return undefined;
    var fiveElementCron = cronString
        .replace('?', '*')
        .split(' ')
        .slice(1, 6)
        .join(' ');
    return fiveElementCron;
};
exports.quartzCronToCron = quartzCronToCron;
/**
 * Takes a schedule object and converts it to a Quartz Cron String
 * @param schedule
 */
var trigTimedToQuartzCron = function (trigTimed) {
    if (!trigTimed)
        return undefined;
    var period = trigTimed.period, dayOfWeek = trigTimed.dayOfWeek, dayOfMonth = trigTimed.dayOfMonth, minuteOfHour = trigTimed.minuteOfHour, hourOfDay = trigTimed.hourOfDay;
    if (period === 'hourly') {
        return "0 ".concat(minuteOfHour, " * * * ? *");
    }
    else if (period === 'daily') {
        return "0 ".concat(minuteOfHour, " ").concat(hourOfDay, " * * ? *");
    }
    else if (period === 'weekly') {
        return "0 ".concat(minuteOfHour, " ").concat(hourOfDay, " ? * ").concat((dayOfWeek ? dayOfWeek : 0) + 1, " *");
    }
    else if (period === 'monthly') {
        return "0 ".concat(minuteOfHour, " ").concat(hourOfDay, " ").concat(dayOfMonth ? dayOfMonth + 1 : 1, " * ? *");
    }
};
exports.trigTimedToQuartzCron = trigTimedToQuartzCron;
//# sourceMappingURL=schedules.js.map